module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rack",
      "title": "Note on Transliteration"
    }
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiii",
      "title": "xiii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041203_Contents#tra"
    }
  }, [_vm._v("NOTE ON TRANSLITERATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE TRANSLITERATION SYSTEM USED THROUGHOUT THIS BOOK RELIES")]), _vm._v(" primarily on that of the Library of Congress. Exceptions are made for individuals who have adopted specific spellings utilizing the Latin alphabet or whose names have acquired common spellings (for example, "), _c('i', [_vm._v("Rachmaninoff")]), _vm._v(", "), _c('i', [_vm._v("Chaliapin")]), _vm._v(", or "), _c('i', [_vm._v("Tolstoy")]), _vm._v("). All translations are my own unless otherwise noted."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "title": "xiv"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3189f4ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041203_Transliteration.vue
// module id = 75
// module chunks = 0